import useCashierLink from "@casino/legacy/client/hooks/feature/useCashierLink";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import Button from "@casino/legacyUi/ClientButton";

const DepositToPlayButton = () => {
  const { onClick } = useCashierLink({
    cashierPath: "deposit",
  });

  return (
    <Button fullWidth variant="primary" size="xs" onClick={onClick}>
      <Translate id="general.deposit_to_play" />
    </Button>
  );
};

export default DepositToPlayButton;
